import React from 'react';
import './styles.css'

const NotFound = () => (
	<div className="contenedor">
		<h1>404 - Not Found!</h1>
	</div>
)

export default NotFound